import { locale } from './../../ModuleEditor/util/locale-wrapper';
import { FIELD_TYPES } from './fieldTypes';

const FIELD_PROFILES = {
  NONE:                     '',
  NAME:                     'name',
  ADDRESS:                  'address',
  EMAIL:                    'email',
  DATE:                     'date',
  TIME:                     'time',
  PHONE:                    'phone',
  WEBSITE:                  'website',
  YOUTUBE_URL:              'youtube_url',
  COUNTRY:                  'country',
  INFO:                     'info',
  UPLOAD:                   'upload',
  HTML:                     'html',
  TITLE:                    'title',
  COMPANY:                  'company',
  ROLE:                     'role',
  INFLUENCE:                'influence',
  MARKETING_OPT_IN:         'marketing_opt_in',
  SUBMIT_ACTION:            'submit_action',
  MULTI_OPT_IN_CUSTOM:      'brand_opt_in_custom',
  MULTI_OPT_IN_BRAND:       'brand_opt_in_list',
  MULTI_OPT_IN_GROUP:       'group_opt_in_list',
  MULTI_OPT_IN_THIRD_PARTY: 'third_party_opt_in_list',
};
const FIELD_PROFILES_ALL = _.values(FIELD_PROFILES);

const PROFILE_LIST = [
  { text: locale('None'), value: FIELD_PROFILES.NONE }, //the ones without a 'availableForFields' are considered as 'common profiles' that should be available to all fields.
  { text: locale('Name'), value: FIELD_PROFILES.NAME },
  { text: locale('Address'), value: FIELD_PROFILES.ADDRESS },
  { text: locale('Email'), value: FIELD_PROFILES.EMAIL },
  { text: locale('Date'), value: FIELD_PROFILES.DATE },
  { text: locale('Time'), value: FIELD_PROFILES.TIME },
  { text: locale('Phone'), value: FIELD_PROFILES.PHONE },
  { text: locale('Website'), value: FIELD_PROFILES.WEBSITE },
  { text: locale('Youtube Url'), value: FIELD_PROFILES.YOUTUBE_URL },
  { text: locale('Country'), value: FIELD_PROFILES.COUNTRY },
  { text: locale('Info'), value: FIELD_PROFILES.INFO },
  { text: locale('Upload'), value: FIELD_PROFILES.UPLOAD },
  { text: locale('Marketing Opt In'), value: FIELD_PROFILES.MARKETING_OPT_IN },
  { text: locale('Submit Action'), value: FIELD_PROFILES.SUBMIT_ACTION },
  { text: locale('Company'), value: FIELD_PROFILES.COMPANY },
  { text: locale('Influence'), value: FIELD_PROFILES.INFLUENCE },
  { text: locale('Role'), value: FIELD_PROFILES.ROLE },
  { text: locale('Title'), value: FIELD_PROFILES.TITLE },
  { text: locale('Html'), value: FIELD_PROFILES.HTML, availableForFields: [FIELD_TYPES.HTML] },
  { text: locale('Custom'), value: FIELD_PROFILES.MULTI_OPT_IN_CUSTOM, availableForFields: [FIELD_TYPES.MULTI_OPTIN] },
  {
    text:               locale('Marketing Brand'),
    value:              FIELD_PROFILES.MULTI_OPT_IN_BRAND,
    availableForFields: [FIELD_TYPES.MULTI_OPTIN],
  },
  {
    text:               locale('Marketing Group'),
    value:              FIELD_PROFILES.MULTI_OPT_IN_GROUP,
    availableForFields: [FIELD_TYPES.MULTI_OPTIN],
  },
  {
    text:               locale('Marketing Third Party'),
    value:              FIELD_PROFILES.MULTI_OPT_IN_THIRD_PARTY,
    availableForFields: [FIELD_TYPES.MULTI_OPTIN],
  },
];

/**
 * function is going to filter the list of profiles.
 * @param fieldType - field type we are going to filter for
 * @param showCommonProfiles - will also list common profiles. The only field NOT listing common profiles is FIELD_TYPES.MULTI_OPTIN, but leaving it configurable for now.
 * @param listProfileNone - will also list profile 'NONE'. The only field NOT listing profile NONE is FIELD_TYPES.MULTI_OPTIN
 * @returns {list of text/value pairs}
 */
const filterProfilesByFieldType = (fieldType, showCommonProfiles, listProfileNone) => {
  showCommonProfiles = showCommonProfiles != undefined ? showCommonProfiles : true; //by default will include the common profiles
  listProfileNone = listProfileNone != undefined ? listProfileNone : true; //by default will include the profile 'NONE'
  const filteredProfiles = _.filter(PROFILE_LIST, profile => {
    const isRestrictedProfile = profile.hasOwnProperty('availableForFields') && profile.availableForFields.length > 0;
    if (profile.value == FIELD_PROFILES.NONE && !listProfileNone) {
      return false;
    }
    return (
      (!isRestrictedProfile && showCommonProfiles) ||
      (isRestrictedProfile && profile.availableForFields.indexOf(fieldType) > -1)
    );
  });
  return filteredProfiles;
};

export { FIELD_PROFILES, PROFILE_LIST, FIELD_PROFILES_ALL, filterProfilesByFieldType };

export default FIELD_PROFILES;
